<div class="checkbox-container" (mouseleave)="isHover=false" (mouseenter)="isHover=true" (click)="handleInputClick()">
    <input
        class="checkbox-input"
        [attr.data-testid]="testId"
        type="checkbox"
        tabindex="0"
        [checked]="checked"
        [disabled]="disabled"
        (change)="$event.stopPropagation();"
    />
    <ui-kit-svg class="circle"
                matRipple
                [matRippleDisabled]="disabled"
                [matRippleCentered]="true"
                [name]="'ic_checkbox' + (checked ? '_checked': '')"
                [class.i-24]="appearance === 'small'"
                [class.i-28]="appearance === 'default'"
                [class.c-primary-green-800]="!disabled && checked"
                [class.c-primary-gray-400]="!disabled && !checked"
                [class.c-primary-gray-200]="disabled">
    </ui-kit-svg>
    @if (withLabel) {
        <div class="ml-8"
             fxFlex
             [class.t4]="appearance === 'small'"
             [class.t-button]="appearance === 'default'"
             [class.c-primary-green-800]="!disabled && isHover"
             [class.c-primary-gray-900]="!disabled && !isHover"
             [class.c-primary-gray-200]="disabled">
            <ng-content></ng-content>
        </div>
    }
</div>
